module.exports = __webpack_public_path__ + "static/img/12.c34711d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/zh/12.png
// module id = FUNM
// module chunks = 0